import React, { Suspense, lazy, useEffect, useState } from "react";
import "./App.css";
import { useAuth } from "./Service/AuthService";
import { Navigate, Route, Routes } from "react-router-dom";
import { HomeScreenLoader } from "./CommonFields/HomeScreenLoader/HomeScreenLoader";
 
import EntranceLoginPage from "./Component/Admin/EntranceLoginPage/EntranceLoginPage";
import EntranceRegisterPage from "./Component/Admin/EntranceLoginPage/EntranceRegisterPage";
import NewEntranceExam from "./Component/Admin/Admission/NewEntranceExams/NewEntrance";
import QrScannerPage from "./Component/Admin/QrScanner/QrScannerPage";
import Maintenance from "./Component/Admin/MaintenanceAlert/Maintenance";
import PaymentExpired from "./Component/Admin/PaymentExpired/PaymentExpired";
import { toast } from "react-toastify";
import useOnlineStatus from "./GlobalComponent/Utils/useOnlineStatus"
import { fetchMaintenanceStatus } from "./Service/ApiServices";
import NoInternet from "./Component/Admin/NoInternet/Internet";
import LoginPage from "./Component/LoginForm/NewLogin";
const EnhancedSchoolDashboard = lazy(() =>
  import("./Component/Admin/Dashboard/EnhancedSchoolDashboard")
);

 
 
// const NewEntranceExam = lazy(() =>
//   import("./Component/Admin/Admission/NewEntranceExam/NewEntrance")
// );

const QrcodeDetailPage = lazy(() =>
  import("./Component/Pages/QrcodeDetailPage/QrcodeDetailPage")
);
const LoginForm = lazy(() => import("./Component/LoginForm/LoginForm"));
const Home = lazy(() => import("./Component/Home/Home"));

const Navigation = () => {
  const { token, checkValidToken } = useAuth();
  const isOnline = useOnlineStatus();
  useEffect(() => {
    if (token) {
      checkValidToken(token);
    }
  }, []);
  const [activeAlert, setActiveAlert] = useState(null);
  const [maintenanceResponse, setMaintenanceResponse] = useState({});

  useEffect(() => {
    const abortController = new AbortController();

    const checkMaintenance = async (signal) => {
      try {
        const res = await fetchMaintenanceStatus(signal);
        const status = res?.response;
        if (!status) return;

        const now = new Date(status.server_time || new Date());
        const start = status.start_time ? new Date(status.start_time) : null;
        const end = status.end_time ? new Date(status.end_time) : null;
        setMaintenanceResponse(status);

        if (status.is_active) {
          setActiveAlert(status.alert_type || "maintenance");
        } else {
          setActiveAlert(null);
          if (status.is_scheduled && start && now < start && (status.alert_type === "maintenance" || !status.alert_type)) {
            toast.warning(
              `Scheduled Maintenance: ${start.toLocaleString()} to ${end ? end.toLocaleString() : ""}`,
              { duration: 20000 }
            );
          }
        }
      } catch (err) {
        console.error("Maintenance check failed:", err);
      }
    };

    checkMaintenance(abortController.signal);
    return () => {
      abortController.abort();
    };
  }, []);

  if (!isOnline) return <NoInternet />;

  // ✅ If blocking alert is active
  if (activeAlert) {
    switch (activeAlert) {
      case "maintenance":
        return (
          <Maintenance
            startTime={maintenanceResponse?.start_time ? new Date(maintenanceResponse.start_time) : new Date()}
            endTime={maintenanceResponse?.end_time ? new Date(maintenanceResponse.end_time) : new Date()}
            message={maintenanceResponse?.message}
          />
        );
      case "payment":
        return <PaymentExpired alertResponse={maintenanceResponse} />;
      default:
        break;
    }
  }

  return (
    <Suspense fallback={<HomeScreenLoader />}>
      <Routes>
        <Route path="/qr-code" element={<QrcodeDetailPage />} />
        <Route path="/qr-scan" element={<QrScannerPage />} />

        {token ? (
          <>
            <Route path="/" element={<EnhancedSchoolDashboard />} />
            <Route path="/EntranceExam/signup" element={<EntranceRegisterPage />} />
            <Route path="/EntranceExam/login" element={<EntranceLoginPage />} />
            <Route path="/EntranceExam" element={<NewEntranceExam />} />
            <Route path="*" element={<Navigate to="/" />} />
          </>
        ) : (
          <>
            <Route path="/login/:school_code" element={<LoginPage />} />
            <Route path="/login" element={<Home />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </>
        )}
      </Routes>
    </Suspense>
  );
};


export default Navigation;
